import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { OrganizationsResponseBody, MeResponseBody } from '@ilteducation/my-account-types';
import { getMe } from './api';

type Organization = OrganizationsResponseBody & { updatedAt: number };

const myAccountStore = defineStore(
  'my-account',
  () => {
    const me = ref<MeResponseBody | undefined>(undefined);
    const isLoadingMyAccount = ref(false);

    const organizations = ref<Organization>({
      data: [],
      meta: { totalCount: 0 },
      updatedAt: Date.now(),
    });

    const load = async () => {
      if (isLoadingMyAccount.value) {
        console.log('Already loading me');
        return;
      }
      if (!me.value) {
        me.value = {
          uid: '',
          speakingBookRights: false,
          email: '',
          emailVerified: false,
          firstname: 'Unknown',
          lastname: '',
          username: 'Unknown',
          sharedAccount: false,
          hidePasswordChange: false,
          identifiers: [],
        };
      }

      isLoadingMyAccount.value = true;
      try {
        me.value = await getMe();
      } finally {
        isLoadingMyAccount.value = false;
      }
    };

    const reset = () => {
      me.value = undefined;
      isLoadingMyAccount.value = false;
      organizations.value = {
        data: [],
        meta: { totalCount: 0 },
        updatedAt: 0,
      };
    };

    const setOrganization = (orgs: Organization) => {
      organizations.value = orgs;
    };

    return {
      me,
      isLoading: computed(() => isLoadingMyAccount.value),
      organizations,
      setOrganization,
      load,
      reset,
    };
  },
  {
    // @ts-ignore
    persist: true,
  },
);

export default myAccountStore;
